import React from "react";
import { useNavigate } from "react-router-dom";
import Section from "./impl/Section";

import {
    UserIcon,
    TicketIcon,
    DirectoryIcon,
    FileIcon,
    DocumentsIcon
} from "@/commons/resources/images/AdminIcons";

const Sections: React.FC = () => {
    useNavigate();
    return (
        <>
            <Section
                sectionTitle="Gestione Utenti"
                sectionPermission="adminpages.section.view.users"
                color={"#1a2930"}
                image={UserIcon}
                buttons={[
                    {
                        title: "Gruppi",
                        page: "groups",
                        permission: "adminpages.openpage.groups",
                        hide: false
                    },
                    {
                        title: "Utenti",
                        page: "profiles",
                        permission: "adminpages.openpage.profiles",
                        hide: false
                    },
                    {
                        title: "Informazioni",
                        page: "infos",
                        permission: "adminpages.openpage.infos",
                        hide: false
                    }
                ]}
            />

            <Section
                sectionTitle="Gestione Reports"
                sectionPermission="adminpages.section.view.reports"
                color={"#301a1a"}
                image={TicketIcon}
                buttons={[
                    {
                        title: "Reports",
                        page: "/reports",
                        permission: "adminpages.openpage.reports",
                        hide: false
                    },
                    {
                        title: "Categorie",
                        page: "/categories",
                        permission: "adminpages.openpage.categories",
                        hide: false
                    }
                ]}
            />

            <Section
                sectionTitle="Supporto"
                sectionPermission="adminpages.openpage.infos"
                color={"#1a3030"}
                image={DirectoryIcon}
                buttons={[
                    {
                        title: "Aiuti Moderazione",
                        page: "/support",
                        permission: "adminpages.openpage.infos",
                        hide: false
                    },
                    {
                        title: "Manuale Helper",
                        page: "https://kb-helper.jebbe96.it",
                        permission: "adminpages.openpage.infos",
                        hide: false
                    }
                ]}
            />

            <Section
                sectionTitle="Logs"
                sectionPermission="adminpages.openpage.logs"
                color={"#802800"}
                image={FileIcon}
                buttons={[
                    {
                        title: "Chat pubbliche",
                        page: "/logs/chats/public",
                        permission: "adminpages.openpage.logs",
                        hide: false
                    },
                    {
                        title: "Chat private",
                        page: "/logs/chats/private",
                        permission: "adminpages.openpage.logs",
                        hide: false
                    },
                    {
                        title: "Lista Bans",
                        page: "https://bans.eblcraft.it/bans.php",
                        permission: "adminpages.openpage.logs",
                        hide: false
                    }
                ]}
            />

            <Section
                sectionTitle="Documenti"
                sectionPermission="admin.documents"
                color={"#004f77"}
                image={DocumentsIcon}
                buttons={[
                    {
                        title: "In arrivo",
                        page: "/",
                        permission: "admin.documents.upload",
                        hide: false
                    }
                ]}
            />
        </>
    );
};

export default Sections;